import React, { Component } from 'react';
import {provideIntlService } from '@progress/kendo-react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

class GridNumberFormatter extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}
	formatNumber = (number_string) => {
    console.log(number_string);
		return (number_string + '').replace(',', '');
	}
	render() {
		return (
			<th colSpan={this.props.colSpan} style={this.props.style}>
				{
					this.props.dataItem[this.props.field] != null ?
					this.formatNumber(this.props.dataItem[this.props.field])
				 :''
				}
			</th>
		);
	}
}
export default withRouter(connect(
)(GridNumberFormatter));
